import type { DataVaultModel, ValidationMessage } from "./types";

export function computeValidation(model: DataVaultModel): ValidationMessage[] {
  const messages: ValidationMessage[] = [];

  model.hubs.forEach((hub) => {
    if (!hub.record.target_table?.trim()) {
      messages.push({ level: "error", message: `Hub ${hub.id} is missing target table.` });
    }
  });

  model.satellites.forEach((satellite) => {
    if (!satellite.parentHubId) {
      messages.push({
        level: "warning",
        message: `Satellite ${satellite.record.target_table || satellite.id} has no parent hub.`
      });
    }
  });

  model.links.forEach((link) => {
    if ((link.connectedHubIds ?? []).length < 2) {
      messages.push({
        level: "warning",
        message: `Link ${link.record.target_table || link.id} should connect at least two hubs.`
      });
    }
  });

  return messages;
}
